import {
  ReportClient,
  RosterPersonDTO,
  VRAccomplishmentDTO,
  TrainingResultVm,
  VRFilterDTO,
  TrainingExpirationPersonDTO,
} from "./generatedFetchClient";
import { defineStore, acceptHMRUpdate } from "pinia";

let reportclient = new ReportClient();

// A store instance to manage report api calls
export const useReportStore = defineStore({
  id: "reportStore",
  state: () => {
    return {
      trainingResults: null as TrainingResultVm | null,
      rosterResults: [] as RosterPersonDTO[],
      vrResults: [] as VRAccomplishmentDTO[],
      vrFilterResults: [] as VRFilterDTO[],
      trainingExpirationResults: [] as TrainingExpirationPersonDTO[],
      rangeStart: new Date(new Date().setFullYear(new Date().getFullYear() - 5)),
      rangeEnd: new Date(),
    };
  },
  actions: {
    setAuthToken(token: string) {
      reportclient.setAuthToken(token);
    },
    async getTrainingReport(
      portalId: number,
      startDate: Date,
      endDate: Date,
      excludeTestUsers: boolean
    ): Promise<boolean> {
      try {
        this.rangeStart = startDate;
        this.rangeEnd = endDate;
        this.trainingResults = await reportclient.getTrainingResults(
          portalId,
          startDate,
          endDate,
          excludeTestUsers
        );
      } catch (apiError: any) {
        console.error("error loading Training report results", apiError);
        return false;
      }
      return true;
    },
    async getRosterReport(portalId: number, excludeTestUsers: boolean): Promise<boolean> {
      try {
        this.rosterResults = await reportclient.getRoster(portalId, excludeTestUsers);
      } catch (apiError: any) {
        console.error("error loading Roster report results", apiError);
        return false;
      }
      return true;
    },
    async getVRReport(portalId: number, excludeTestUsers: boolean): Promise<boolean> {
      try {
        this.vrResults = await reportclient.getVRReport(portalId, excludeTestUsers);
        console.log("reportStore");
        console.log(this.vrResults);
      } catch (apiError: any) {
        console.error("error loading VR Accomplishments report results", apiError);
        return false;
      }
      return true;
    },
    async getVRFilterReport(portalId: number, excludeTestUsers: boolean): Promise<boolean> {
      try {
        this.vrFilterResults = await reportclient.getVRFilterReport(portalId, excludeTestUsers);
        console.log("reportStore.vrFilterReport", this.vrFilterResults);
      } catch (apiError: any) {
        console.error("error loading VR Filter report results", apiError);
        return false;
      }
      return true;
    },
    async getTrainingExpirationReport(
      portalId: number,
      excludeTestUsers: boolean
    ): Promise<boolean> {
      try {
        this.trainingExpirationResults = await reportclient.getTrainingExpirationReport(
          portalId,
          excludeTestUsers
        );
      } catch (apiError: any) {
        console.error("error loading training expiration report results", apiError);
        return false;
      }
      return true;
    },
  },
  getters: {},
});

//Enable Hot Module Replacement
// https://pinia.esm.dev/cookbook/hot-module-replacement.html
if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(useReportStore as any, (import.meta as any).hot));
}
